<div class="trip-booking-resource-column fx-column">
  @if (trip_booking_resource) {
    <div [ngClass]="is_pickup && trip_booking_resource.activated ? 'pickup' : ''" class="resource-row fx-row fx-justify-start fx-items-center">
      @if (trip_booking_resource.optional) {
        <div [matTooltip]='not_activable_reason'>
          @if (!trip_booking_resource.activated) {
            <button class="checkbox" [disabled]='not_activable_reason' mat-icon-button [matTooltip]='"Risorsa opzionale NON attivata" | translate' (click)='activateResource()'>
              <mat-icon>check_box_outline_blank</mat-icon>
            </button>
          }
          @if (trip_booking_resource.activated) {
            <button class="checkbox" [disabled]='not_activable_reason' mat-icon-button [matTooltip]='"Risorsa opzionale attivata" | translate' (click)='deactivateResource()'>
              <mat-icon>check_box</mat-icon>
            </button>
          }
        </div>
      }
      <div (click)='selected()' class="fx-row fx-justify-space-between fx-items-center fx-flex-1-1-auto" style="cursor: pointer">
        <span class="ml-4 info_resource fx-row fx-justify-start fx-items-center" style="gap: 8px">
          <span class="resource_description">{{trip_resource.description}}</span>
          @if (is_pickup) {
            <span class="pickup">PICK-UP</span>
          }
          <span class='secondary-text mat-caption ml-4'>({{ trip_booking_resource.optional ? 'Opzionale' : 'Inclusa' | translate}})</span>
        </span>
        <!--<strong class="price" *ngIf='tripBookingResource.optional'>{{tripBookingResource.total_amount | currency:'EUR' }}</strong>-->
        <button class="page_view_btn" mat-icon-button color='accent' matTooltip='Dettaglio Risorsa'>
          <mat-icon>arrow_forward_ios</mat-icon>
        </button>
      </div>
    </div>
    @if (is_pickup && trip_booking_resource.activated) {
      <div class="resource_meeting_point fx-row fx-justify-start fx-items-center" style="gap: 8px">
        <mat-icon>place</mat-icon>
        <span class='ml-4 mr-4'>{{'Punto di ritrovo' | translate}}: @if (bookingStepService.meetingPointPickupResource) {
          <span class='meeting_point_description' [matTooltip]='bookingStepService.meetingPointPickupResource.description'>{{bookingStepService.meetingPointPickupResource.description}}</span>
        }</span>
        <span>@if (bookingStepService.loadPickupMeetingPoint) {
          <mat-spinner diameter='20'></mat-spinner>
        }</span>
        @if (!bookingStepService.loadPickupMeetingPoint) {
          <button mat-icon-button color='accent' [matTooltip]='"Modifica punto di ritrovo" | translate' (click)='bookingStepService.editMeetingPoint(datasetRS.record.value)'>
            <mat-icon>edit</mat-icon>
          </button>
        }
      </div>
    }
  }
</div>